var map = {
	"./jee_answerkey_full_mock_1_jee_full_mock_1.json": [
		85,
		85
	],
	"./neet_answerkey_DynamicNEETTest.json": [
		4920,
		920
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8300;
module.exports = webpackAsyncContext;